import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import * as actions from '../../actions'
import { AnulacionIngreso0, AnulacionIngreso1 } from './steps'
import { FORM_ANULACION_INGRESO } from '../../../../config/forms'

import { INTERVALO_CORTO } from '../../../../config/settings'
import { ToastContainer } from 'react-toastify'

const selector = formValueSelector(FORM_ANULACION_INGRESO)

class AnulacionIngreso extends Component {
  constructor (props) {
    super(props)
    this.nextStep = this.nextStep.bind(this)
    this.prevStep = this.prevStep.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  nextStep () {
    const {
      verificarAnulacionIngreso,
      anulacionIngresoStep,
      numero
    } = this.props

    if (anulacionIngresoStep === 0) {
      verificarAnulacionIngreso(numero)
    }
  }

  prevStep () {
    this.props.anulacionIngresoPrevStep()
  }

  handleSubmit () {
    this.props.anularIngresoCpa(this.props.destroy)
  }

  render () {
    const {
      anulacionIngresoStep
    } = this.props

    return (
      <div className='camiones-anulacionIngreso-container'>
        <h2>Anulación de Ingreso CPE</h2>
        {anulacionIngresoStep === 0 && <AnulacionIngreso0 onSubmit={this.nextStep} />}
        {anulacionIngresoStep === 1 &&
          <AnulacionIngreso1 onSubmit={this.handleSubmit} onPrev={this.prevStep} />}
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    numero: selector(state, 'numero'),
    anulacionIngresoStep: state.camionesIngreso.anulacionIngresoStep
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({ form: FORM_ANULACION_INGRESO })(AnulacionIngreso)
)
